<template>
  <div class="column-overflow">
    <el-tooltip
      :content="content"
      placement="top"
      :disabled="!isShowTooltip"
      v-bind="$attrs"
    >
      <div
        class="column-overflow__hidden ellipsis"
        @mouseenter="visibilityChange($event)"
      >
        {{ content || "-" }}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "100%",
    },
    content: {
      type: String,
      default: "",
    },
    direction: {
      type: String,
      default: "horizontal",
    },
  },
  data() {
    return {
      isShowTooltip: false,
    };
  },
  methods: {
    visibilityChange(event) {
      const ev = event.target;
      let ev_size = ev.scrollWidth;
      let content_size = ev.clientWidth;
      if (this.direction === "vertical") {
        ev_size = ev.scrollHeight;
        content_size = ev.clientHeight;
      }
      if (ev_size > content_size) {
        this.isShowTooltip = true;
      } else {
        this.isShowTooltip = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.column-overflow {
  width: 100%;

  &__hidden {
    display: block;
    width: 100%;
    white-space: nowrap;
  }
}
</style>
